<template>
  <aside v-if="$route.name !== 'Login' && $route.name !== 'Login with return'" class="main-sidebar">
    <ThinkTankLinks class="mb-4"></ThinkTankLinks>
    <EquityLinks v-if="isEEManager" class="mb-4"></EquityLinks>
    <AdminControls v-if="isAdmin" class="mb-4"></AdminControls>
    <AdminLinkControls v-if="isLinkAdmin" class="mb-4"></AdminLinkControls>
    <!-- <CurrentVEAward class="mb-4"></CurrentVEAward>
    <CurrentIdeaChallenge class="mb-4"></CurrentIdeaChallenge> -->
    <HelpfulResources class="mb-4" v-if="$route.name !== 'Recognition' && $route.name !== 'Recognition' && $route.name !== 'Innovation Always On Site'"></HelpfulResources>
  </aside>
</template>

<script>
import ThinkTankLinks from '@/components/ThinkTankLinks'
import CurrentVEAward from '@/components/CurrentVEAward'
import CurrentIdeaChallenge from '@/components/CurrentIdeaChallenge'
import HelpfulResources from '@/components/HelpfulResources'
import AdminControls from '@/components/AdminControls'
import AdminLinkControls from '@/components/AdminLinkControls'
import EquityLinks from '@/components/EquityLinks'
import { mapGetters } from 'vuex'
export default {
  components: {
    ThinkTankLinks,
    CurrentVEAward,
    HelpfulResources,
    AdminControls,
    AdminLinkControls,    
    CurrentIdeaChallenge,
    EquityLinks
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isEEManager',
      'isLinkAdmin'
    ])
  }
}
</script>

<style lang="less">
  .currentContent {
    p {
      margin-bottom: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue